import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { fetchJSON } from '../../helpers/api';
import { getHubspotDealsSuccess, getHubspotDealsFailure } from './actions';
import { GET_HUBSPOT_DEALS } from './constants';

const SERVER_URL = process.env.REACT_APP_KDM_API_ENDPOINT;

function* getHubspotDealsSaga() {
  const options = {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
  };

  try {
    const response = yield call(fetchJSON, `${SERVER_URL}/User/hubspotdeals`, options);
    const { status, ...data } = response;
    yield put(getHubspotDealsSuccess(data));
  } catch (error) {
    let message;
    if (error.statusCode) {
      const errorDesc = (error.error && error.error.description) ? error.error.description : null;
      switch (error.statusCode) {
        case 500:
          message = 'Internal Server Error';
          break;
        case 401:
          message = errorDesc || 'Invalid credentials UNAUTHENTICATED';
          break;
        default:
          message = errorDesc || 'An error occurred';
      }
    } else {
      message = error.description || error.message || 'An error occurred';
    }
    yield put(getHubspotDealsFailure(message));
  }
}

function* watchGetHubspotDeals() {
  yield takeEvery(GET_HUBSPOT_DEALS, getHubspotDealsSaga);
}

export default function* hubspotDealsSaga() {
  yield all([
    fork(watchGetHubspotDeals),
  ]);
}
